import { DripSchedule } from "@/types";

export type DripConfig = DripSchedule & {
  day: string;
  skip?: boolean;
};

export const defaultSchedules: {
  new: DripConfig[];
  quoted: DripConfig[];
} = {
  new: [
    {
      day: "As soon as lead comes in",
      on_day: 1,
      channel: "email",
      slot: null,
      run_hour: null,
      run_minute: null,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "As soon as lead comes in",
      on_day: 1,
      channel: "text",
      slot: null,
      run_hour: null,
      run_minute: null,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Same Day",
      on_day: 1,
      channel: "email",
      slot: "morning",
      run_hour: 15,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Same Day",
      on_day: 1,
      channel: "text",
      slot: "afternoon",
      run_hour: 3,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Next Day",
      on_day: 2,
      channel: "email",
      slot: "morning",
      run_hour: 3,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Next Day",
      on_day: 2,
      channel: "text",
      slot: "afternoon",
      run_hour: 3,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    // {
    //   day: "Day 3",
    //   on_day: 3,
    //   channel: "email",
    //   slot: "morning",
    //   run_hour: 9,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    // {
    //   day: "Day 3",
    //   on_day: 3,
    //   channel: "text",
    //   slot: "afternoon",
    //   run_hour: 14,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    {
      day: "Day 4",
      on_day: 4,
      skip: true,
      channel: "email",
      slot: "morning",
      run_hour: 9,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Day 4",
      on_day: 4,
      skip: true,
      channel: "text",
      slot: "afternoon",
      run_hour: 14,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    // {
    //   day: "Day 5",
    //   on_day: 5,
    //   channel: "email",
    //   slot: "morning",
    //   run_hour: 9,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    // {
    //   day: "Day 5",
    //   on_day: 5,
    //   channel: "text",
    //   slot: "afternoon",
    //   run_hour: 14,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    // {
    //   day: "Day 6",
    //   on_day: 6,
    //   skip: true,
    //   channel: "email",
    //   slot: "morning",
    //   run_hour: 9,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    // {
    //   day: "Day 6",
    //   on_day: 6,
    //   skip: true,
    //   channel: "text",
    //   slot: "afternoon",
    //   run_hour: 14,
    //   run_minute: 0,
    //   enabled: false,
    //   subject: "",
    //   body: "",
    //   lead_status: status,
    // },
    {
      day: "Day 7",
      on_day: 7,
      skip: true,
      channel: "email",
      slot: "morning",
      run_hour: 9,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
    {
      day: "Day 7",
      on_day: 7,
      skip: true,
      channel: "text",
      slot: "afternoon",
      run_hour: 14,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "initial",
    },
  ],
  quoted: [
    {
      day: "Same Day",
      on_day: 1,
      channel: "text",
      slot: "afternoon",
      run_hour: null,
      run_minute: null,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Next Day",
      on_day: 2,
      channel: "email",
      slot: "morning",
      run_hour: 9,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Next Day",
      on_day: 2,
      channel: "text",
      slot: "afternoon",
      run_hour: 14,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Day 4",
      on_day: 4,
      channel: "email",
      slot: "morning",
      run_hour: 9,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Day 4",
      on_day: 4,
      channel: "text",
      slot: "afternoon",
      run_hour: 14,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Day 7",
      on_day: 7,
      channel: "email",
      slot: "morning",
      run_hour: 9,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
    {
      day: "Day 7",
      on_day: 7,
      channel: "text",
      slot: "afternoon",
      run_hour: 14,
      run_minute: 0,
      enabled: false,
      subject: "",
      body: "",
      lead_status: "quoted",
    },
  ],
};

export const dayName = (day: number, slot: string | null) => {
  if (day === 1 && !slot) {
    return "As soon as lead comes in";
  }
  if (day === 1 && slot) {
    return "Same Day";
  }
  if (day === 2 && slot) {
    return "Next Day";
  }
  return `Day ${day}`;
};
